/* nuovae-rich.js — variant sync across all tier selectors + hero, sticky ATC, nav scroll, analytics (dedup). */
(function(){
  var root=document.querySelector('[data-nvx-pdp]'); if(!root) return;
  var form=document.getElementById('nvx-form');
  var hidden=root.querySelector('[data-variant]');
  function selectVariant(vid, priceText){
    if(hidden) hidden.value=vid;
    root.querySelectorAll('[data-selp]').forEach(function(e){e.textContent=priceText;});
  }
  // all tier groups (hero + offer) stay in sync
  root.querySelectorAll('[data-tier]').forEach(function(grp){
    grp.querySelectorAll('[data-price]').forEach(function(opt){
      opt.addEventListener('click',function(){
        root.querySelectorAll('[data-price]').forEach(function(x){x.setAttribute('data-sel','false');});
        // set selected on all matching-vid opts across groups
        var vid=opt.getAttribute('data-vid'), p=opt.getAttribute('data-price');
        root.querySelectorAll('[data-vid="'+vid+'"]').forEach(function(x){x.setAttribute('data-sel','true');});
        var r=opt.querySelector('input[type=radio]'); if(r) r.checked=true;
        selectVariant(vid,p);
      });
    });
  });
  // proxy ATC buttons submit the real form
  root.querySelectorAll('[data-atc-proxy]').forEach(function(b){b.addEventListener('click',function(){ if(form) form.requestSubmit ? form.requestSubmit() : form.submit(); });});
  // sticky mobile ATC
  var mainAtc=root.querySelector('[data-atc]'), st=root.querySelector('[data-sticky]');
  if(mainAtc&&st&&'IntersectionObserver' in window){ new IntersectionObserver(function(es){es.forEach(function(e){st.hidden=e.isIntersecting;});},{threshold:0}).observe(mainAtc); }
  // nav scrolled state
  var hdr=root.querySelector('[data-hdr]');
  if(hdr) window.addEventListener('scroll',function(){hdr.classList.toggle('scrolled',window.scrollY>60);},{passive:true});
  // analytics dedup
  var fired={}, last=0;
  function push(ev,d){ if(ev==='view_item'&&fired[ev])return; fired[ev]=1; try{(window.dataLayer=window.dataLayer||[]).push(Object.assign({event:ev},d||{}));}catch(e){} }
  push('view_item',{currency:'USD'});
  if(form) form.addEventListener('submit',function(){var now=Date.now();if(now-last<1000)return;last=now;push('add_to_cart',{currency:'USD'});});
})();
